"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiTag = function IconUiTag(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M23 .05v6.2L10 17.3v26.67h28V17.3L25 6.253V.05zm13 18.179v23.745H12V18.229l11-9.351v4.857a2.5 2.5 0 1 0 2 0V8.878z"
  }), _react.default.createElement("path", {
    d: "M20.244 28.21v.007a6.886 6.886 0 0 0-1.061 5.106 4.558 4.558 0 0 0 .969 1.857 3.786 3.786 0 0 0 .615.622 5 5 0 0 0 3.033 1.229h.383a5.664 5.664 0 0 0 2.918-1.2l.088-.075a4.958 4.958 0 0 0 1.482-2.434 6.572 6.572 0 0 0-1.061-5.106l-3.652-6.13zm6.485 4.639a2.935 2.935 0 0 1-.875 1.417 3.677 3.677 0 0 1-1.754.765h-.26a2.991 2.991 0 0 1-1.8-.769 1.935 1.935 0 0 1-.332-.333 2.628 2.628 0 0 1-.583-1.069 4.974 4.974 0 0 1 .832-3.617l1.985-3.275 1.958 3.286a4.636 4.636 0 0 1 .829 3.595z"
  }));
};

IconUiTag.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiTag;
exports.default = _default;